import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import CardoGroup from '@cotyorg/ccx-organism-cardo-group/components/CardoGroup';
import StandardLayout from '../../templates/StandardLayout';
import { productsBaseBreakpointConfig } from './cardo.config';

const SearchResultsComponent = ({ products, sectionHeadings }) => {
  const cleanedProducts = products.map((product) => ({
    ...product,
    title: product.title && product.title.replace(/<br\s*\/?>/g, ''),
  }));

  return (
    <StandardLayout>
      <div className="search-results">
        <div className="grid-container">
          {R.length(products) ? (
            <Heading level={1} extraClass="h4 search-results__heading">
              {R.path(['results', 'heading'], sectionHeadings)}
            </Heading>
          ) : (
            <div className="text--center">
              <Heading level={1} extraClass="h3">
                {R.path(['noResults', 'heading'], sectionHeadings)}
              </Heading>
              <Paragraph>
                {R.path(['noResults', 'introduction'], sectionHeadings)}
              </Paragraph>
            </div>
          )}
        </div>

        <div className="product-list">
          <div className="grid-container">
            <div className="grid-x grid-padding-x">
              <CardoGroup
                data={cleanedProducts}
                zoomOnHover
                contentTheme="transparent"
                baseBreakpointConfig={productsBaseBreakpointConfig}
                isTitleUnderlined={false}
                headingLevel={5}
              />
            </div>
          </div>
        </div>
      </div>
    </StandardLayout>
  );
};

SearchResultsComponent.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
};

export default connect(({ content }) => ({
  products: R.path(['cardoGroup', 'products'], content),
  sectionHeadings: R.prop('sectionHeadings', content),
}))(SearchResultsComponent);
